export default function FlagSpain() {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2483_27230"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="12"
      >
        <rect width="16" height="12" fill="white" />
      </mask>
      <g mask="url(#mask0_2483_27230)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 0V12H16V0H0Z"
          fill="#FFB400"
        />
        <mask
          id="mask1_2483_27230"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="12"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0V12H16V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_2483_27230)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0V3H16V0H0Z"
            fill="#C51918"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 9V12H16V9H0Z"
            fill="#C51918"
          />
          <rect
            x="2.50391"
            y="5.13672"
            width="0.56"
            height="2.912"
            fill="#F1F9FF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.2873 4.63184H2.2793V4.91184H2.4473V5.13584H3.1193V4.91184H3.2873V4.63184Z"
            fill="#C88A02"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.1193 8.21619H3.2873V8.49619H2.2793V8.21619H2.4473V7.99219H3.1193V8.21619Z"
            fill="#C88A02"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.78262 4.68827C2.90449 4.68827 2.91688 4.64238 2.98877 4.57384C3.0446 4.52062 3.17462 4.45462 3.17462 4.38027C3.17462 4.21016 2.99912 4.07227 2.78262 4.07227C2.56613 4.07227 2.39062 4.21016 2.39062 4.38027C2.39062 4.4631 2.48016 4.51849 2.54787 4.57384C2.61919 4.63216 2.67155 4.68827 2.78262 4.68827Z"
            fill="#AD1619"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.2793 8.49609H3.2873V8.94409C3.2873 8.94409 3.1613 8.88809 3.0353 8.88809C2.9093 8.88809 2.7833 8.94409 2.7833 8.94409C2.7833 8.94409 2.6573 8.88809 2.5313 8.88809C2.4053 8.88809 2.2793 8.94409 2.2793 8.94409V8.49609Z"
            fill="#005BBF"
          />
          <mask
            id="mask2_2483_27230"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="2"
            y="8"
            width="2"
            height="1"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.2793 8.49609H3.2873V8.94409C3.2873 8.94409 3.1613 8.88809 3.0353 8.88809C2.9093 8.88809 2.7833 8.94409 2.7833 8.94409C2.7833 8.94409 2.6573 8.88809 2.5313 8.88809C2.4053 8.88809 2.2793 8.94409 2.2793 8.94409V8.49609Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2_2483_27230)"></g>
          <rect
            x="7.99219"
            y="5.13672"
            width="0.56"
            height="2.912"
            fill="#F1F9FF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.77558 4.63184H7.76758V4.91184H7.93558V5.13584H8.60758V4.91184H8.77558V4.63184Z"
            fill="#C88A02"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.60758 8.21619H8.77558V8.49619H7.76758V8.21619H7.93558V7.99219H8.60758V8.21619Z"
            fill="#C88A02"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.27091 4.68827C8.39277 4.68827 8.40516 4.64238 8.47706 4.57384C8.53288 4.52062 8.66291 4.45462 8.66291 4.38027C8.66291 4.21016 8.4874 4.07227 8.27091 4.07227C8.05441 4.07227 7.87891 4.21016 7.87891 4.38027C7.87891 4.4631 7.96845 4.51849 8.03615 4.57384C8.10748 4.63216 8.15984 4.68827 8.27091 4.68827Z"
            fill="#AD1619"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.76758 8.49609H8.77558V8.94409C8.77558 8.94409 8.64958 8.88809 8.52358 8.88809C8.39758 8.88809 8.27158 8.94409 8.27158 8.94409C8.27158 8.94409 8.14558 8.88809 8.01958 8.88809C7.89358 8.88809 7.76758 8.94409 7.76758 8.94409V8.49609Z"
            fill="#005BBF"
          />
          <mask
            id="mask3_2483_27230"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="7"
            y="8"
            width="2"
            height="1"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.76758 8.49609H8.77558V8.94409C8.77558 8.94409 8.64958 8.88809 8.52358 8.88809C8.39758 8.88809 8.27158 8.94409 8.27158 8.94409C8.27158 8.94409 8.14558 8.88809 8.01958 8.88809C7.89358 8.88809 7.76758 8.94409 7.76758 8.94409V8.49609Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask3_2483_27230)"></g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.35239 7.48791C8.35239 7.60618 8.40885 7.71754 8.50981 7.83994L8.85367 7.55632L8.88651 7.54624L8.90481 7.40293C8.93862 7.1382 8.82547 6.99155 8.59233 6.88554L8.57627 6.87846C8.54432 6.86444 8.4746 6.83382 8.45105 6.82253C8.40183 6.79893 8.36125 6.77553 8.32337 6.74799C8.28602 6.72083 8.24593 6.6952 8.19758 6.66715C8.4861 6.6208 8.64202 6.58661 8.76162 6.53508C9.04785 6.41176 9.08476 6.12538 8.80966 5.93592C8.4346 5.67763 7.43053 5.65439 6.98986 5.88192L7.19539 6.27999C7.41164 6.16834 7.90326 6.14728 8.24754 6.20457C8.19518 6.21372 8.13647 6.22336 8.07066 6.23369L7.87398 6.26418C7.73647 6.28556 7.64266 6.31272 7.57314 6.36005C7.43124 6.45666 7.41022 6.63072 7.51148 6.75912C7.55423 6.81334 7.61013 6.85389 7.69471 6.90295C7.72185 6.9187 7.75107 6.93474 7.79031 6.95568L7.88666 7.0069C7.96739 7.05025 8.02035 7.08156 8.05987 7.11031C8.12178 7.15533 8.18528 7.19194 8.25736 7.22649C8.29613 7.24509 8.40749 7.29363 8.40689 7.29336L8.41346 7.29631C8.37458 7.34893 8.35239 7.41334 8.35239 7.48791ZM2.49339 7.83994C2.59435 7.71754 2.65081 7.60618 2.65081 7.48791C2.65081 7.41334 2.62862 7.34893 2.58974 7.29631L2.59631 7.29336C2.59571 7.29363 2.70707 7.24509 2.74584 7.22649C2.81792 7.19194 2.88142 7.15533 2.94333 7.11031C2.98285 7.08156 3.03581 7.05025 3.11654 7.0069L3.21289 6.95568C3.25213 6.93474 3.28135 6.9187 3.30849 6.90295C3.39308 6.85389 3.44897 6.81334 3.49172 6.75912C3.59298 6.63072 3.57196 6.45666 3.43006 6.36005C3.36054 6.31272 3.26673 6.28556 3.12922 6.26418L2.93254 6.23369C2.86673 6.22336 2.80802 6.21372 2.75566 6.20457C3.09994 6.14728 3.59156 6.16834 3.80781 6.27999L4.01334 5.88192C3.57267 5.65439 2.5686 5.67763 2.19354 5.93592C1.91844 6.12538 1.95535 6.41176 2.24158 6.53508C2.36118 6.58661 2.5171 6.6208 2.80562 6.66715C2.75727 6.6952 2.71718 6.72083 2.67983 6.74799C2.64195 6.77553 2.60137 6.79893 2.55215 6.82253C2.52861 6.83382 2.45889 6.86443 2.42694 6.87846L2.41087 6.88554C2.17773 6.99155 2.06458 7.1382 2.09839 7.40293L2.11669 7.54624L2.14952 7.55632L2.49339 7.83994ZM2.2052 7.4696L2.20449 7.47166L2.20503 7.4702L2.2052 7.4696Z"
            fill="#AD1619"
          />
          <path
            d="M2.96158 6.2002L3.12688 6.23439V6.48076C2.95083 6.62123 2.50391 6.85798 2.50391 6.85798V6.2002H2.96158Z"
            fill="#F1F9FF"
          />
          <path
            d="M8.15756 6.2002L7.99226 6.23439V6.48076C8.16831 6.62123 8.61523 6.85798 8.61523 6.85798V6.2002H8.15756Z"
            fill="#F1F9FF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.38661 3.60289V3.5209C7.09856 3.31418 6.79693 3.21082 6.48169 3.21082C6.17948 3.07708 5.87358 3.02516 5.564 3.05508C5.56408 3.05412 5.56413 3.05364 5.56413 3.05364C5.09864 3.00809 4.62952 3.21082 4.62952 3.21082C4.15667 3.21082 3.72461 3.5209 3.72461 3.5209V3.60289L4.28942 4.17016C4.28942 4.17016 4.44835 4.71596 5.56123 4.5879C5.56162 4.58877 5.56183 4.58921 5.56183 4.58921C5.56183 4.58921 6.299 4.56909 6.3508 4.55187C6.37135 4.54503 6.39267 4.53881 6.41445 4.53245C6.55884 4.49029 6.72367 4.44217 6.82179 4.17016L7.38661 3.60289ZM5.56147 3.08441C5.55914 3.11192 5.55544 3.15672 5.55108 3.21399C5.55662 3.17294 5.56034 3.12988 5.56147 3.08441Z"
            fill="#AD1619"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.75781 3.69899L3.79619 3.6582L4.30903 4.1407C4.40638 4.11453 4.9348 3.97988 5.52504 3.97325V3.97299L5.54749 3.97306L5.56995 3.97299V3.97325C6.22389 3.98059 6.80195 4.14509 6.80195 4.14509C6.80195 4.14509 6.79576 4.19816 6.78071 4.26056C6.79664 4.2279 6.81551 4.1916 6.83732 4.15154L6.84273 4.14454L7.35964 3.6582L7.39802 3.69899L6.88437 4.18225C6.80943 4.32026 6.77169 4.41136 6.77169 4.4492C6.77169 4.50693 6.62149 4.54119 6.32836 4.57639C6.09872 4.60396 5.82771 4.62247 5.60602 4.62523V4.62559L5.57792 4.6255L5.54981 4.62559V4.62523C5.32813 4.62247 5.05711 4.60396 4.82747 4.57639C4.53434 4.54119 4.38414 4.50693 4.38414 4.4492C4.38414 4.44204 4.38279 4.43297 4.38009 4.42205C4.35054 4.3844 4.32975 4.32282 4.31593 4.26728C4.30295 4.2413 4.28813 4.21293 4.27146 4.18225L3.75781 3.69899ZM6.62445 4.45029C6.66369 4.46865 6.69514 4.45034 6.72001 4.41518C6.71785 4.42489 6.71651 4.43367 6.71596 4.44153C6.71268 4.44368 6.70764 4.44627 6.70104 4.44905C6.68259 4.4568 6.65442 4.46507 6.61777 4.47343C6.54574 4.48986 6.4432 4.5062 6.32169 4.52079C6.08439 4.54928 5.80223 4.56802 5.57792 4.5695C5.3536 4.56802 5.07144 4.54928 4.83414 4.52079C4.71263 4.5062 4.61009 4.48986 4.53806 4.47343C4.50734 4.46642 4.48258 4.45948 4.46451 4.45285L4.47054 4.45029C4.59287 4.39305 5.40182 4.33933 5.54749 4.33006C5.69317 4.33933 6.50212 4.39305 6.62445 4.45029ZM6.77872 4.44003L6.77787 4.44101L6.77838 4.4403L6.77872 4.44003Z"
            fill="#C88A02"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.55472 2.67291C5.6475 2.67291 5.72272 2.5977 5.72272 2.50491C5.72272 2.41213 5.6475 2.33691 5.55472 2.33691C5.46193 2.33691 5.38672 2.41213 5.38672 2.50491C5.38672 2.5977 5.46193 2.67291 5.55472 2.67291Z"
            fill="#005BBF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.49148 2.03809H5.60814V2.11179H5.68437V2.22845H5.60814V2.46179H5.68437V2.57845H5.41406V2.46179H5.49148V2.22845H5.41406V2.11179H5.49148V2.03809Z"
            fill="#C88A02"
          />
          <rect
            x="5.4707"
            y="2.67188"
            width="0.224"
            height="0.728"
            fill="#C88A02"
          />
          <path
            d="M3.85254 3.64807L3.54492 3.6365C3.69006 2.7977 4.40484 2.38672 5.54705 2.38672C6.69074 2.38672 7.40301 2.79948 7.53723 3.6414L7.12119 3.68504C7.05587 3.27533 6.36964 2.90456 5.55307 2.90456C4.73501 2.90456 3.92397 3.23524 3.85254 3.64807Z"
            fill="#C88A02"
          />
          <path
            opacity="0.3"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.73633 4.63184H7.37633V7.90225C7.37633 7.90225 7.10594 8.99984 5.55633 8.99984C4.00672 8.99984 3.73633 7.87331 3.73633 7.87331V4.63184Z"
            fill="#E1E5E8"
          />
          <mask
            id="mask4_2483_27230"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="3"
            y="4"
            width="5"
            height="5"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.73633 4.63184H7.37633V7.90225C7.37633 7.90225 7.10594 8.99984 5.55633 8.99984C4.00672 8.99984 3.73633 7.87331 3.73633 7.87331V4.63184Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask4_2483_27230)">
            <rect
              x="3.73633"
              y="6.64746"
              width="1.848"
              height="2.184"
              fill="#FFC034"
            />
            <rect
              x="3.73633"
              y="4.57617"
              width="1.848"
              height="2.128"
              fill="#AD1619"
            />
            <rect
              x="5.5293"
              y="6.5918"
              width="1.848"
              height="2.128"
              fill="#AD1619"
            />
            <rect
              x="5.5293"
              y="4.63184"
              width="1.96"
              height="2.072"
              fill="#F1F9FF"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.74255 8.72153C6.74255 8.72153 5.55645 8.81478 5.55645 8.0498C5.55645 8.0498 5.54514 8.72153 4.30664 8.72153V9.32544H6.74255V8.72153Z"
              fill="#F1F9FF"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.55672 7.0962C5.78868 7.0962 5.97672 6.89562 5.97672 6.6482C5.97672 6.40077 5.78868 6.2002 5.55672 6.2002C5.32476 6.2002 5.13672 6.40077 5.13672 6.6482C5.13672 6.89562 5.32476 7.0962 5.55672 7.0962Z"
              fill="#005BBF"
              stroke="#AD1619"
              stroke-width="0.583333"
            />
          </g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.5 6C4.77614 6 5 5.77614 5 5.5C5 5.22386 4.77614 5 4.5 5C4.22386 5 4 5.22386 4 5.5C4 5.77614 4.22386 6 4.5 6Z"
            fill="#C88A02"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.5 6C6.77614 6 7 5.77614 7 5.5C7 5.22386 6.77614 5 6.5 5C6.22386 5 6 5.22386 6 5.5C6 5.77614 6.22386 6 6.5 6Z"
            fill="#C37C9C"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.5 8C6.77614 8 7 7.77614 7 7.5C7 7.22386 6.77614 7 6.5 7C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8Z"
            fill="#FFC034"
          />
          <path
            d="M4.5 8C4.77614 8 5 7.77614 5 7.5C5 7.22386 4.77614 7 4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8Z"
            fill="#AD1619"
          />
        </g>
      </g>
    </svg>
  )
}
